import * as React from "react";
import Modal from "../../ui/modal/Modal";
import EditFinanceProductForm from "../form/edit/EditFinanceProductForm";
import FinanceProduct from "../../../model/financeProduct/FinanceProduct";

interface IComponentProps {
	/**
	 * On successful edited finance product callback.
	 */
	closeModal: () => void;
	/**
	 * Finance product to edit
	 */
	editedFinanceProduct: FinanceProduct;
}

export default class EditFinanceProductModal extends React.Component<IComponentProps, {}> {
	render() {
		return (
			<Modal onCloseClicked={this.props.closeModal} title={"Edit Finance Product"}>
				<EditFinanceProductForm closeModal={this.props.closeModal}
										editedFinanceProduct={this.props.editedFinanceProduct}/>
			</Modal>
		);
	}
}
